import styles from './style.postcss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { PageCard, Grid, testClass } from 'omni-common-ui';
import classnames from 'classnames';

import ExpansionButton from 'components/ExpansionButton';
import ReadOnlyField from '../ReadOnlyField';

const BOOKWORK = 'Bookwork';
const ONLINE = 'Online';
const ATTENDANCE = 'Attendance';

class ReportCard extends Component {
  render() {
    const { isExpanded, reportCardInfo, onExpandButtonClick } = this.props;
    let reportCardInfoDisplayItems = [];
    prepareReportCardInfoDisplayItems.call(this);

    return <PageCard className={classnames(styles.ReportCard_container, testClass('report-card'))}>
      <PageCard.Heading className={styles.ReportCard_heading}>
        <span>Report card</span>
        {
          reportCardInfo.lastUpdatedTimeUtc &&
          <span>Last updated {`${reportCardInfo.lastUpdatedTimeUtc}`}</span>
        }
      </PageCard.Heading>
      <PageCard.Content className={styles.ReportCard_content}>
        <Grid className={styles.ReportCard_grid}>
          <Grid.Group>
            {renderGridItems()}
          </Grid.Group>
        </Grid>
      </PageCard.Content>
      {renderExpansionButton()}
    </PageCard>;

    function renderGridItems() {
      return reportCardInfoDisplayItems.map((source) => {
        const size = { xs: 12, sm: 6, md: 6 };
        return <Grid.Item key={source.title}
            xs={size.xs}
            sm={size.sm}
            md={size.md}
            className={styles.ReportCard_item}>
          <ReadOnlyField boardTitle={source.title}
              boardValue={source.value}
              className={source.className} />
        </Grid.Item>;
      });
    }

    function prepareReportCardInfoDisplayItems() {
      reportCardInfo.skillResults.forEach(({ name, score }) => {
        reportCardInfoDisplayItems.push({
          title: name,
          value: score,
        });
      });

      if (reportCardInfo.homeworkCompletion) {
        reportCardInfoDisplayItems.push({
          title: BOOKWORK,
          value: reportCardInfo.homeworkCompletion,
        });
      }
      reportCardInfoDisplayItems.push({
        title: ONLINE,
        value: reportCardInfo.online,
      });
      this.props.shouldShowAttendance && reportCardInfoDisplayItems.push({
        title: ATTENDANCE,
        value: reportCardInfo.attendance,
      });

      reportCardInfoDisplayItems = resortByDisplayingOrder(reportCardInfoDisplayItems);
      reportCardInfoDisplayItems = hideReportCardItemsIfNeeded(reportCardInfoDisplayItems);
    }

    function resortByDisplayingOrder(items) {
      if (! items || ! items.length > 0) return;

      const numberOfRows = Math.ceil(items.length / 2);
      const sortedItems = items.map((_item, index) => {
        const item = _item;
        if (index < numberOfRows) {
          item.displayOrder = 1 + (2 * index);
          return item;
        }
        item.displayOrder = 2 + (2 * (index - numberOfRows));
        return item;
      });
      return sortedItems.sort((a, b) => a.displayOrder - b.displayOrder);
    }

    function hideReportCardItemsIfNeeded(items) {
      if (isExpanded || ! items || ! items.length > 0) return items;
      return items.slice(0, 2);
    }

    function renderExpansionButton() {
      return <ExpansionButton isExpand={isExpanded}
          onExpansionButtonClick={() => onExpandButtonClick()} />;
    }
  }
}

ReportCard.propTypes = {
  reportCardInfo: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onExpandButtonClick: PropTypes.func.isRequired,
  shouldShowAttendance: PropTypes.bool.isRequired,
};

export default ReportCard;



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/ReportCard/index.jsx